const appUrl1 = "http://localhost:3000";
const appUrl = "http://golalitatwffer.com";
const appUrla = "https://161.97.91.128";
export {
    appUrl
}